import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SCSS_COLORS } from '../../../../../colors';

import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-state-has-join',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .teacher-assigned-chip {
        min-width: 136px;
        height: 16px;
        border-radius: 4px;
      }
    `,
  ],
  template: `
    <lp2-private-class-banner-container>
      <lp2-private-class-center-header-banner>
        <div class="d-flex flex-1 flex-column">
          <p class="mt-2 mb-3 ml-sm-4 fw-bold fs-5 lh-4 bg-transparent text-center">
            {{ stateTextKey | translate }}
          </p>
          <span
            [style.transform]="'translateY(' + (selectedLesson ? 8 : 72) + 'px)'"
            class="teacher-assigned-chip ml-auto mr-auto px-2 py-0 bg-white fw-bold fs-7 lh-6 private-class-light-blue"
          >
            <i class="fa fa-check orange fs-7 lh-6 mr-2"></i>
            {{ 'oeapp.studybundle.pc.confirmLesson.teacherAssigned' | translate | uppercase }}
          </span>
          <lp2-private-class-lesson-detail-box
            [selectedLesson]="selectedLesson"
            [showBorderBottom]="true"
          ></lp2-private-class-lesson-detail-box>
          <div class="d-flex flex-wrap justify-content-center">
            <button
              *ngIf="buttonCaption"
              class="btn btn-accent-contained fw-bold fs-5 d-flex justify-content-between align-items-center"
              (click)="onClick()"
            >
              <lp2-animated-circle-icon
                [backgroundColor]="colors['$white']"
                [color]="colors['$orange']"
                [rippleColor]="colors['$private-class-light-blue']"
                width="8"
                height="8"
                class="mr-3"
              >
              </lp2-animated-circle-icon>
              {{ buttonCaption | translate }}
            </button>
          </div>
        </div>
      </lp2-private-class-center-header-banner>
    </lp2-private-class-banner-container>
  `,
})
export class PrivateClassStateHasJoinComponent {
  @Input() buttonCaption: string;
  @Input() stateTextKey: string;
  @Input() selectedLesson: PrivateClassLesson;
  @Output() join = new EventEmitter();

  public colors = SCSS_COLORS;

  public onClick() {
    this.join.emit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-states/private-class-state-has-join.component.ts